import { EmployeeDto } from "./employee.dto";
import { PaginatorInfo } from "./generic.dto";
import { PayPeriodDto } from "./pay-period.dto";

type PartialSalary = {
  id: number;
  employeeId: number;
  startPayPeriodId: number;
  amount: number;
  expired: boolean;
  groupId: number | null;
  createdAt: Date;
  expiryLastModifiedAt: Date | null;
  modifiedAt: Date | null;
}

export class CreatePartialSalaryDto {
  employeeId!: number
  startPayPeriodId!: number
  amount!: number
  groupId?: number
}

export class UpdatePartialSalaryDto {
  startPayPeriodId?: number
  amount?: number
  expired?: boolean
  groupId?: number
  /**
 * @ignore
 */
  expiryLastModifiedAt?: Date
}

export interface PartialSalaryDto extends PartialSalary {
  employee?: EmployeeDto;
  startingPayPeriod?: PayPeriodDto;
}

export interface PartialSalaryPaginator extends PaginatorInfo<PartialSalaryDto> {}

export class QueryPartialSalaryDto {
  employeeId?: number
  startPayPeriodId?: number
  expired?: boolean
  companyId?: number
  groupId?: number
  page: number = 1;
  limit?: number;
  orderBy: PartialSalaryOrderBy = PartialSalaryOrderBy.CREATED_AT_ASC;
}

export enum PartialSalaryOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc'
}

export class QueryPartialSalaryGivenPayPeriodDto {
  employeeId?: number;
  page: number = 1;
  limit?: number;
  orderBy: PartialSalaryOrderBy = PartialSalaryOrderBy.CREATED_AT_ASC;
}

export class ExportPartialSalaryQueryDto {
  employeeNumber?: boolean;
  startPayPeriodCode?: boolean;
  amount?: boolean;
  expired?: boolean;
  groupCode?: boolean;
  orderBy: PartialSalaryOrderBy = PartialSalaryOrderBy.CREATED_AT_ASC;
}

export class UploadPartialSalariesResponse {
  successful!: {
    partialSalaryId?: number;
    rowNumber?: number;
  }[];
  failed!: {
    rowNumber?: number;
    errors: {
      column: string;
      reason: string;
    }[]
  }[];
}